export const DANSKE_BANK_LOAN_VALIDATION_PRODUCT_ID = 'danske-bank-loan-validation';

const normalizeOrganisationValue = (value) => String(value || '').trim().toLowerCase();

export function resolveInitialTargetOrganisationId({ organisationId, availableOrganisations, currentTargetOrganisationId }) {
    const availableIds = (availableOrganisations || []).map(({ organisationId: orgId }) => orgId);

    if (availableIds.includes(currentTargetOrganisationId)) return currentTargetOrganisationId;
    if (availableIds.includes(organisationId)) return organisationId;
    return availableIds[0];
}

export function isDanskeBankOrganisation(organisation) {
    if (!organisation) return false;

    const candidates = typeof organisation === 'string'
        ? [organisation]
        : [organisation.organisationId, organisation.name];

    return candidates
        .map(normalizeOrganisationValue)
        .some((value) => value.includes('danske-bank') || value.includes('danske bank'));
}

export function filterCreateOrderProductOptions({ productOptions, hasUserId }) {
    if (hasUserId) return productOptions || [];

    return (productOptions || []).filter(
        (product) => product?.value !== DANSKE_BANK_LOAN_VALIDATION_PRODUCT_ID,
    );
}

export function filterCreateOrderProductsById({ productsById, hasUserId }) {
    if (hasUserId) return productsById || {};

    const nextProductsById = { ...(productsById || {}) };
    delete nextProductsById[DANSKE_BANK_LOAN_VALIDATION_PRODUCT_ID];
    return nextProductsById;
}

export function getDefaultSelectedProductIds({ targetOrganisation, productOptions }) {
    if (!isDanskeBankOrganisation(targetOrganisation)) return [];

    const hasDanskeBankLoanValidation = (productOptions || []).some(
        (product) => product?.value === DANSKE_BANK_LOAN_VALIDATION_PRODUCT_ID,
    );

    return hasDanskeBankLoanValidation ? [DANSKE_BANK_LOAN_VALIDATION_PRODUCT_ID] : [];
}

export function requiresCreateOrderFileUpload({ selectedProductIds }) {
    return (selectedProductIds || []).includes(DANSKE_BANK_LOAN_VALIDATION_PRODUCT_ID);
}

export function shouldDisableCreateOrder({ organisationsLoading, organisationsError, targetOrganisationId }) {
    return organisationsLoading || !!organisationsError || !targetOrganisationId;
}
